
import cn from './i18n/cn.json';
import en from './i18n/en.json';
// import ja from './i18n/ja.json';
// import ko from './i18n/ko.json';
// import th from './i18n/th.json';
// import tw from './i18n/tw.json';

const language_key = 'user_language';
const languages = {
    en, cn//, tw, ja, ko, th
};

export const LanguageSymbol = () => {
    return localStorage.getItem(language_key) || 'en'
}

// # 设置语言
export const SetLanguage = (value = 'en') => {
    localStorage.setItem(language_key, value)
}

export const LanguageList = () => {
    const data = []
    Object.keys(languages).forEach(item => {
        const value = languages[item]['language']
        if(value) {
            data.push({title : value, symbol : item})
        }
    })
    return data
}

export const T = (key = '') => {
    if(typeof key === 'string') {
        if(key.length > 0) {
            return (languages[LanguageSymbol()] || {})[key]
        }
    }
    return ''
}